import React from "react";
import { Table } from "react-bootstrap";
import { CardBody } from "../../../../../../_metronic/_partials/controls";
import { currencyFormatter } from '../../../../../../_metronic/_helpers/UtilityHelpers';

export default function OrganizationUsageTable({ count = {} }) {
  return (
    <>
      <CardBody>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Komponen</th>
              <th>Keterangan</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Jumlah Database Donatur</td>
              <td>Donatur</td>
              <td>{count.donorCount}</td>
            </tr>
            <tr>
              <td>Jumlah Total Donasi</td>
              <td>Donasi</td>
              <td>{currencyFormatter(parseInt(count.donationAmountSum))}</td>
            </tr>
            <tr>
              <td>Jumlah Total Transaksi</td>
              <td>Transaksi</td>
              <td>{count.donationCount}</td>
            </tr>
            <tr>
              <td>Jumlah Total Program</td>
              <td>Program</td>
              <td>{count.programCount}</td>
            </tr>
          </tbody>
        </Table>
      </CardBody>
    </>
  );
}
